export default "__VITE_ASSET__BFFCVM9i__"